import React, { useEffect } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as DeliveryDriversActions from "../../../store/actions/DeliveryDrivers";
import {
  DriverBasicDetailsContainer,
  FieldHolder,
} from "../../../constants/assets/DriverDetailsContainers";
import MigrationDetailsField from "../../../constants/DeliveryDrivers/MigrationDetailsFields.json";
import BlankState from "../../Common/BlankState";
import variables from "../../../constants/assets/variables";
import { FieldsContainer } from "../../../constants/assets/containers";
import { getReadableDateTime } from "../../../utils";
import { isNil } from "lodash-es";

const DriverMigrationDetails = ({ driverMigrationDetails, getDriverMigrationDetails }) => {
  const { id } = useParams();

  const getFieldValue = (field, key, name) => {
    if (key.includes("complete_time")) {
      if (field[key] === null || field[key] === undefined){
        return "N/A";
      }
      return getReadableDateTime(field[key]);
    } 
    else if (key.includes("created_at")){
      return getReadableDateTime(field[key]);
    }
    else if (key.includes("info")) {
      return renderPaymentDetails(field[key]);
    }
    else return field[key];
  };

  const renderPaymentDetails = (info) => {
    const {payment_details} = info
    if (payment_details && payment_details.pendencies) {
      return (
        <>
          {Object.entries(payment_details.pendencies).map(([pdKey, pdValue]) => (
            <div key={pdKey} style={{ display: 'block' }}>
            {pdKey}: {pdValue !== null ? pdValue.toString() : 'N/A'}
            </div>
          ))}
        </>
      );
    } else {
      return <span>N/A</span>;
    }
  };
  
  useEffect(() => {
    if (driverMigrationDetails.length === 0) {
      getDriverMigrationDetails(id);
    }
  }, []);

  return (
    <DriverMigrationDetailsContainer>
      <FieldsContainer>
        <FieldHolder repeat={8} display="grid">
          {MigrationDetailsField.map((field, index) => {
            return <span key={index}>{field.name}</span>;
          })}
        </FieldHolder>
        {driverMigrationDetails.length > 0 ? (
          driverMigrationDetails.map((log, index) => {
            return (
              <FieldHeading repeat={8} display="grid">
                {MigrationDetailsField.map((field, idx) => {
                  return (
                    <span key={index + idx}>
                      {getFieldValue(log, field.key)}
                    </span>
                  );
                })}
              </FieldHeading>
            );
          })
        ) : (
          <BlankState message=" " />
        )}
      </FieldsContainer>
    </DriverMigrationDetailsContainer>
  );
};

const DriverMigrationDetailsContainer = styled(DriverBasicDetailsContainer)``;

const FieldHeading = styled(FieldHolder)`
  span {
    color: ${variables.black};
    word-break: break-all;
  }
`;

function mapStateToProps(state) {
  const { DeliveryDrivers } = state;
  return {
    driverMigrationDetails: DeliveryDrivers.driverMigrationDetails,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDriverMigrationDetails: bindActionCreators(
      DeliveryDriversActions.getDriverMigrationDetails,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DriverMigrationDetails);
